import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { Search, Newspaper } from '@mui/icons-material';

interface HeroSectionProps {
  onSearchClick?: () => void;
  onNewsClick?: () => void;
}

const HeroSection = ({ onSearchClick, onNewsClick }: HeroSectionProps) => {
  const scrollToNews = () => {
    const newsSection = document.getElementById('news-section');
    if (newsSection) {
      newsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSearch = () => {
    const searchSection = document.getElementById('alumni-search-section');
    if (searchSection) {
      searchSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #E8F5E9 0%, #FFF9E6 50%, #FAFAFA 100%)',
        py: 8,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(165, 214, 167, 0.2) 0%, rgba(255, 213, 79, 0.2) 100%)',
          filter: 'blur(60px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -100,
          left: -100,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(255, 213, 79, 0.2) 0%, rgba(165, 214, 167, 0.2) 100%)',
          filter: 'blur(80px)',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                mb: 2,
                fontSize: { xs: '2rem', md: '3rem' },
              }}
            >
              ยินดีต้อนรับสู่
              <br />
              <Box component="span" sx={{ color: 'primary.dark' }}>
                ระบบศิษย์เก่า
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: 'text.secondary',
                mb: 4,
                lineHeight: 1.6,
                fontSize: { xs: '1.25rem', md: '1.5rem' },
              }}
            >
              เชื่อมโยงศิษย์เก่า คณะพยาบาลศาสตร์
              <br />
              มหาวิทยาลัยราชภัฏสุราษฎร์ธานี
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<Search />}
                onClick={onSearchClick || scrollToSearch}
                sx={{
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                }}
              >
                ค้นหาศิษย์เก่า
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<Newspaper />}
                onClick={onNewsClick || scrollToNews}
                sx={{
                  borderColor: 'secondary.main',
                  color: 'secondary.contrastText',
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  '&:hover': {
                    borderColor: 'secondary.dark',
                    backgroundColor: 'rgba(255, 213, 79, 0.1)',
                  },
                }}
              >
                ข่าวสารล่าสุด
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  maxWidth: 500,
                  height: 350,
                  borderRadius: 4,
                  background: 'linear-gradient(135deg, #A5D6A7 0%, #FFD54F 100%)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                }}
              >
                <Box sx={{ textAlign: 'center', px: 4 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: 'white',
                      fontWeight: 700,
                      mb: 2,
                    }}
                  >
                    คณะพยาบาลศาสตร์
                  </Typography>
                  <Typography variant="h5" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                    มหาวิทยาลัยราชภัฏสุราษฎร์ธานี
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
